<template>
  <bb-modal
    v-if="modalOpened"
    maxWidth="426px"
    noPadding
    closeIconLarge
    smallModalBox
    @close="handleCloseModal"
  >
    <h3 class="modal-title">Promociones bancarias</h3>
    <div class="modal-content">
      <div class="content-wrapper">
        <section class="promo-grid" aria-labelledby="promotional-grid">
          <figure
            v-for="(item, index) in items"
            :key="index"
            class="promo-item"
          >
            <img :src="item.src" :alt="item.alt" class="promo-image" />
            <figcaption class="promo-caption">
              <h3 class="promo-title">{{ item.title }}</h3>
              <p v-if="item.subtitle" class="promo-description">
                {{ item.subtitle }}
              </p>
            </figcaption>
          </figure>
        </section>
      </div>
    </div>
  </bb-modal>
</template>

<script>
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import BbModal from 'common/components/BbModal/BbModal.vue';

  @Component({
    components: {
      BbModal,
    },
    props: {
      items: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
  })
  export default class PromoGrid extends Vue {
    modalOpened = false;
    handleOpenModal() {
      this.modalOpened = true;
    }
    handleCloseModal(trigger = false) {
      this.modalOpened = trigger;
    }
  }
</script>

<style scoped lang="scss">
  .modal-title {
    position: absolute;
    top: 0;
    padding: 16px;
    z-index: 1000;
    color: #333333;
    font-size: 2rem;
    font-family: 'Figtree', sans-serif;
    font-weight: 600;
    line-height: 2.6rem;
    word-wrap: break-word;
  }
  .modal-content {
    position: relative;
    background-color: white;
    text-align: left;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 32px;
    min-height: 15rem;
    justify-content: center;
    padding: 16px;
    border: 0 0 5px 0;
    border-radius: 5px;
  }

  .content-wrapper {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  .promo-grid {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
    gap: 3.2rem;
    padding-bottom: 1.5rem;
    @media (max-width: $screen-md) {
      gap: 1.6rem;
    }
  }

  .promo-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-basis: auto;
    gap: 0.4rem;
    overflow: hidden;
    width: 140px;
  }

  .promo-image {
    height: auto;
    width: 100%;
    object-fit: contain;
  }

  .promo-caption {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0.4rem;
    text-align: center;
    font-family: 'Figtree', sans-serif;
    color: #4d4d4d;
  }

  .promo-title {
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 400;
  }

  .promo-description {
    font-size: 1.2rem;
    line-height: 1.7rem;
    font-weight: 400;
  }
</style>
